<div>
    <app-gateway-svg [height]="'35'"
                     [status]="status"
                     [online]="true"
                     [width]="'35'"
                     style="margin: auto"></app-gateway-svg>
</div>